import { Select } from "antd";
import React, { useState } from "react";

function MultiSelect({
  options,
  placeholder,
  className,
  disabled,
  callBackItems,
}) {
  const [open, setOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const filteredOptions = options.filter(
    (item) => !selectedItems.includes(item)
  );
  console.log(open);

  function handleSelect() {
    setOpen(!open);
  }

  function handleClick() {
    setOpen(!open);
  }

  function handleSearch() {
    setOpen(true);
  }

  function handleChange(e) {
    setSelectedItems(e);
    callBackItems(e);
  }

  return (
    <Select
      mode="multiple"
      value={selectedItems}
      onChange={(e) => {
        handleChange(e);
      }}
      placeholder={placeholder}
      options={filteredOptions.map((item) => ({
        value: item,
        label: item,
      }))}
      open={open}
      onSearch={() => handleSearch()}
      onSelect={() => handleSelect()}
      onClick={() => handleClick()}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
      className={className}
      disabled={disabled}
    />
  );
}

export default MultiSelect;
